<template>
    <div class="help-box" @blur="showBox = false" tabindex="0" @click="showBox = !showBox">
        <i class="fs-14 jfi-info-line over-tip" :class="{'active': showBox}"></i>
        <div :class="[helperClass, {'active': showBox}]" v-if="showBox">
            <slot name="helpmsg"></slot>
            <!-- <a href="javascript:void(0)" class="color-white fr fs-14 uprcse" v-on:click="showBox = false">GOT IT</a> -->
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                showBox:false
            }
        },
        props: [
            "helperClass"
        ],
    }
</script>
